import SimpleIntro from "../../components/General/SimpleIntro";
import AdvancedText from "../../components/General/AdvancedText";
import AdvancesCardList from "../../components/General/AdvancesCardList";
import AdvancedIntro from "../../components/General/AdvancedIntro";

const MedicalTourism = () => {
  return (
    <section>
      <SimpleIntro urlApi="services/medicalTourism/simpleIntro" />

      <div className="container text-center">
        <div style={{ margin: "7rem auto" }}>
          <AdvancedText urlApi="services/medicalTourism/advancedText" />

          <AdvancesCardList urlApi="services/medicalTourism/medicalTourismList" />
        </div>
      </div>

      <AdvancedIntro urlApi="services/medicalTourism/advancedIntro" />
    </section>
  );
};

export default MedicalTourism;
